<template>
  <div class="area">
    <div v-if="!loading && data.length" id="chartdiv" ref="chartdiv" />
  </div>
</template>

<script lang="ts">
import {
  ref,
  shallowRef,
  onMounted,
  onBeforeUnmount,
  defineComponent
} from 'vue'

import { am4core, am4charts } from '@/utils/async_chart_loader'

export default defineComponent({
  name: 'PieChart',
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  setup(props, context) {
    const chartdiv = ref(null)
    const chartBox = shallowRef()

    const renderChart = () => {
      clearChart()
      // @ts-ignore: Object is possibly 'null'.
      const chart = am4core.create(chartdiv.value, am4charts.PieChart)
      // Add data
      chart.data = props.data

      // Add and configure Series
      const pieSeries = chart.series.push(new am4charts.PieSeries())
      pieSeries.dataFields.value = 'value'
      pieSeries.dataFields.category = 'id'

      pieSeries.slices.template.adapter.add(
        'fillOpacity',
        (fillOpacity, target) => {
          // @ts-ignore: Object is possibly 'null'.
          return (target.dataItem.index + 1) * 0.2
        }
      )

      pieSeries.slices.template.adapter.add('fill', (fill, target) => {
        return chart.colors.getIndex(1)
      })

      chartBox.value = chart
    }

    const clearChart = () => {
      if (chartBox.value && !chartBox.value.isDisposed) {
        chartBox.value.dispose()
        chartBox.value = null
      }
    }

    onMounted(() => {
      renderChart()
    })

    onBeforeUnmount(() => {
      clearChart()
    })

    return { chartdiv }
  }
})
</script>

<style lang="scss" scoped>
.area {
  height: 400px !important;
  position: relative;
  .main-chart {
    background: #fff;
    height: 100%;
  }
  .el-radio-group {
    margin: 10px 0;
  }
  .center {
    position: absolute;
    margin: 0;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }
}
#chartdiv {
  width: 100%;
  height: 100%;
}
</style>
